import React, { PureComponent } from "react";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";

import AuthenticateContainer from "./authentication";
import ProtectedRoute from "./authentication/ProtectedRoute";
import Home from "./views";
import ChangePassword from "./views/change-password";
import ChangePasswordSuccess from "./views/change-password/success/";
import ResetPassword from "./views/reset-password";

export const MAIN_PATH = "/claims";
export const LOGIN_PATH = `${MAIN_PATH}/login`;
export const CHANGE_PWD_PATH = `${MAIN_PATH}/change-pwd`;
export const CHANGE_PWD_SUCCESS_PATH = `${MAIN_PATH}/change-pwd-success`;
export const CONFIRM_RESET_PWD_PATH = `${MAIN_PATH}/confirm-reset`;
export const APP_PATH = `${MAIN_PATH}/app`;

type RouteProps = {
  location: any;
  history: any;
  match: any;
};

class Routes extends PureComponent<RouteProps> {
  render() {
    return (
      <Switch>
        <Route exact path={CONFIRM_RESET_PWD_PATH} component={ResetPassword} />
        <Route path={CHANGE_PWD_PATH} component={ChangePassword} />
        <Route
          path={CHANGE_PWD_SUCCESS_PATH}
          component={ChangePasswordSuccess}
        />
        <Route exact path={MAIN_PATH} component={AuthenticateContainer} />
        <ProtectedRoute path={APP_PATH} component={Home} />
        <Redirect push to={MAIN_PATH} />
      </Switch>
    );
  }
}

export default withRouter(Routes);
